;(function () {
  'use strict'

  angular.module('pub.games.service', []).factory('GameService', GameService)

  /** @ngInject */
  function GameService($http, $q, API) {
    function getAll(channelId) {
      var deferred = $q.defer()
      $http
        .get(API.API_URL + 'publisher/channels/' + channelId + '/games')
        .success(deferred.resolve)
        .error(deferred.reject)
      return deferred.promise
    }

    function getById(channelId, gameId) {
      var deferred = $q.defer()
      $http
        .get(API.API_URL + 'publisher/channels/' + channelId + '/games/' + gameId)
        .success(deferred.resolve)
        .error(deferred.reject)
      return deferred.promise
    }

    function create(channelId, model) {
      var deferred = $q.defer()
      $http
        .post(API.API_URL + 'publisher/channels/' + channelId + '/games', model)
        .success(deferred.resolve)
        .error(deferred.reject)
      return deferred.promise
    }

    function update(channelId, gameId, model) {
      var deferred = $q.defer()
      $http
        .put(API.API_URL + 'publisher/channels/' + channelId + '/games/' + gameId, model)
        .success(deferred.resolve)
        .error(deferred.reject)
      return deferred.promise
    }

    function remove(channelId, gameId) {
      var deferred = $q.defer()
      $http
        .delete(API.API_URL + 'publisher/channels/' + channelId + '/games/' + gameId)
        .success(deferred.resolve)
        .error(deferred.reject)
      return deferred.promise
    }

    function reorder(channelId, gameId, order) {
      var deferred = $q.defer()
      $http
        .put(
          API.API_URL + 'publisher/channels/' + channelId + '/games/' + gameId + '/order/' + order,
        )
        .success(deferred.resolve)
        .error(deferred.reject)
      return deferred.promise
    }

    function getCollectibles(channelId) {
      var deferred = $q.defer()
      $http
        .get(API.API_URL + 'publisher/channels/' + channelId + '/collectibles')
        .success(deferred.resolve)
        .error(deferred.reject)
      return deferred.promise
    }

    // Prizes ----------

    function listPublishedPrizes(gameId) {
      var deferred = $q.defer()
      $http
        .get(API.API_URL + 'publisher/channels/games/' + gameId + '/game_prize/published')
        .success(deferred.resolve)
        .error(deferred.reject)
      return deferred.promise
    }

    function listUnpublishedPrizes(gameId) {
      var deferred = $q.defer()
      $http
        .get(API.API_URL + 'publisher/channels/games/' + gameId + '/game_prize/unpublished')
        .success(deferred.resolve)
        .error(deferred.reject)
      return deferred.promise
    }

    function listExpiredPrizes(gameId) {
      var deferred = $q.defer()
      $http
        .get(API.API_URL + 'publisher/channels/games/' + gameId + '/game_prize/expired')
        .success(deferred.resolve)
        .error(deferred.reject)
      return deferred.promise
    }

    function createGamePrize(model) {
      var deferred = $q.defer()
      $http
        .post(API.API_URL + 'publisher/channels/game_prize', model)
        .success(deferred.resolve)
        .error(deferred.reject)
      return deferred.promise
    }

    function updateGamePrize(prizeId, model) {
      var deferred = $q.defer()
      $http
        .put(API.API_URL + 'publisher/channels/game_prize/' + prizeId, model)
        .success(deferred.resolve)
        .error(deferred.reject)
      return deferred.promise
    }

    function deleteGamePrize(prizeId) {
      var deferred = $q.defer()
      $http
        .delete(API.API_URL + 'publisher/channels/game_prize/' + prizeId)
        .success(deferred.resolve)
        .error(deferred.reject)
      return deferred.promise
    }

    return {
      getAll: getAll,
      getById: getById,
      create: create,
      update: update,
      remove: remove,
      reorder: reorder,
      getCollectibles: getCollectibles,
      listPublishedPrizes,
      listUnpublishedPrizes,
      listExpiredPrizes,
      createGamePrize,
      updateGamePrize,
      deleteGamePrize,
    }
  }
})()
